module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Cd-Db-Ec-Ga.48bda27a.png";